import React from "react";

export default function Body({ children }) {
  return (
    <main className="flex-1 overflow-y-auto mt-16 min-h-screen p-2.5">
      {children}
    </main>
  );
}